export default function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=is-number.js.map